class CustomForm extends HTMLElement {
    constructor() {
        super();
        this.currentStep = 1;
        this.allStepElements = this.querySelectorAll('[data-step]');
        this.previousButtonEl = this.querySelector('[data-step-button="previous"]');
        this.nextButtonEl = this.querySelector('[data-step-button="next"]');
        this.totalSteps = this.allStepElements.length;
        this.referenceFiles = [];

        this.bindEvents();
    }

    bindEvents() {
        this.previousButtonEl?.addEventListener('click', (e) => this.handlePreviousStep(e));
        this.nextButtonEl.addEventListener('click', (e) => this.handleNextStep(e));

        this.querySelectorAll('[data-target-el]').forEach(addElButton => {
            addElButton.addEventListener('click', (e) => this.handleAddElButton(e))
        })

        this.manageCalendar();
        this.manageFileUpload();
    }

    handlePreviousStep(e) {
        this.currentStep--;

        if (this.currentStep <= 1) {
            this.currentStep = 1;
            e.currentTarget.setAttribute('disabled', 'true');
        }

        let previousStepEl = this.allStepElements[this.currentStep] || null;
        if (previousStepEl) {
            previousStepEl.classList.add('d-none');
        }

        let currentStepEl = this.allStepElements[this.currentStep - 1] || null;
        if (currentStepEl) {
            currentStepEl.classList.remove('d-none');
        }
    }

    handleNextStep(e) {

        let isInValid = false;
        this.querySelectorAll(`[data-step="${this.currentStep}"] [required]`).forEach(inputEl => {
            let fieldName = inputEl.getAttribute('name');
            let errorEl = this.querySelector(`[data-error-name="${fieldName}"]`);
            if (errorEl) {
                let customFieldName = errorEl.getAttribute('data-name');
                if (!customFieldName) {
                    customFieldName = fieldName.replace('_', ' ');
                    customFieldName = customFieldName.charAt(0).toUpperCase() + customFieldName.slice(1);
                }
                let isValidField = this.validateField(customFieldName, inputEl, errorEl, inputEl.getAttribute('type'));
                if (!isValidField) {
                    isInValid = true;
                }
            }
        })

        if (isInValid) {
            return;
        }

        this.currentStep++;

        if (this.currentStep > this.totalSteps) {
            this.currentStep = this.totalSteps;
            this.handleSubmit();
            return;
        }

        this.previousButtonEl.removeAttribute('disabled');

        let previousStepEl = this.allStepElements[this.currentStep - 2] || null;
        if (previousStepEl) {
            previousStepEl.classList.add('d-none');
        }

        let currentStepEl = this.allStepElements[this.currentStep - 1] || null;
        if (currentStepEl) {
            currentStepEl.classList.remove('d-none');
        }
    }

    handleAddElButton(e) {
        let addElButton = e.currentTarget;
        let referenceEl = this.querySelector(`[data-reference-el="${addElButton.getAttribute('data-target-el')}"]`);

        let count = referenceEl.getAttribute('data-count');
        count = parseInt(count);
        count++;

        let maxCount = referenceEl.getAttribute('data-max-count');
        maxCount = parseInt(maxCount);

        referenceEl.setAttribute('data-count', (count).toString());

        let cloneEl = referenceEl.cloneNode(true);
        cloneEl.removeAttribute('data-count');
        cloneEl.removeAttribute('data-max-count');
        cloneEl.removeAttribute('data-reference-el');
        cloneEl.querySelectorAll('input').forEach(inputEl => {
            let labelEl = inputEl.parentNode.querySelector('label');
            labelEl.setAttribute('for', `${inputEl.id}_${count}`);
            inputEl.setAttribute('id', `${inputEl.id}_${count}`);
            inputEl.value = '';
        })

        cloneEl.querySelectorAll('[data-remove-target-el]').forEach(removeTargetEl => {
            removeTargetEl.classList.remove('d-none');
            removeTargetEl.setAttribute('data-position', count);
            removeTargetEl.addEventListener('click', (e => this.handleRemoveElButton(e)));
        })

        referenceEl.parentNode?.appendChild(cloneEl);

        if (count >= maxCount) {
            addElButton.classList.add('d-none');
        }
    }

    handleRemoveElButton(e) {
        let removeElButton = e.currentTarget;
        let referenceEl = this.querySelector(`[data-reference-el="${removeElButton.getAttribute('data-remove-target-el')}"]`);

        let count = removeElButton.getAttribute('data-position');
        count = parseInt(count);
        count = count - 1;

        referenceEl.setAttribute('data-count', (count).toString());

        referenceEl.parentNode.removeChild(referenceEl.parentNode.children[count]);
        this.querySelector(`[data-target-el="${removeElButton.getAttribute('data-remove-target-el')}"]`)?.classList.remove('d-none');
    }

    async handleSubmit() {

        let submitButtonLoaderEl = this.querySelector('[data-submit-loader]');

        submitButtonLoaderEl?.classList?.remove('d-none');
        this.nextButtonEl?.classList?.add('custom-loading');

        let formData = new FormData(this.querySelector('form'));
        let formObject = {};
        formData.forEach((value, key) => {
            if (formObject[key]) {
                if (key.includes('[]')) formObject[key].push(value);
                else formObject[key] = formObject[key] = [].concat(formObject[key], value);;
            } else {
                if (key.includes('[]')) formObject[key] = [value];
                else formObject[key] = value;
            }
        });

        formObject.reference_links = formObject['reference_links[]'] || [];

        formObject.scope_of_work = [];
        (formObject['scope[]'] || []).forEach((scope, scopeIndex) => {
            let scopeOfWork = {};
            scopeOfWork[`scope_${scopeIndex + 1}`] = scope;
            scopeOfWork[`budget_${scopeIndex + 1}`] = (formObject['budget[]'] || '') ?  formObject['budget[]'][scopeIndex] : '';

            formObject.scope_of_work.push(scopeOfWork)
        });

        let formBuilderId = 'U6DDC6hRZ8cMhLLxkzZruA';
        let formBuilderApiKey = '2a502140057e1971';

        const myHeaders = new Headers();
        myHeaders.append("X-Form-Access-Token", formBuilderApiKey);

        let referenceFileLinks = [];

        for (let referenceFileIndex = 0; referenceFileIndex < this.referenceFiles.length; referenceFileIndex++) {
            let fileFormData = new FormData();
            fileFormData.append(`file_data`, this.referenceFiles[referenceFileIndex], this.referenceFiles[referenceFileIndex].name);

            let fileResponse = {};

            try {
                fileResponse = await fetch(`https://formbuilder.hulkapps.com/forms/file_upload/${formBuilderId}`, {
                    method: "POST",
                    headers: myHeaders,
                    body: fileFormData,
                    redirect: "follow"
                });

                fileResponse = await fileResponse.json();

                if (!fileResponse.error) {
                    referenceFileLinks.push(fileResponse.response);
                }

            } catch (e) {
                console.error(e);
            }
        }

        myHeaders.append("Content-Type", 'application/json');

        let formBody = {
            formResponse: {
                company_name: formObject.company_name,
                client_name: formObject.client_name,
                email: formObject.email,
                phone: formObject.phone,
                project_goals: formObject.project_goals,
                expected_completion_date: formObject.expected_completion_date,
                project_budget: formObject.project_budget,
                scope_of_work: formObject.scope_of_work,
                reference_files: referenceFileLinks,
                reference_links: formObject.reference_links
            }
        };

        try {
            let response = await fetch(`https://formbuilder.hulkapps.com/forms/create_response/${formBuilderId}`, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(formBody),
                redirect: "follow"
            });
            response = await response.json();

            if (!response.company_name) {
                let errorEl = this.querySelector('[data-error-name="submission-error"]');
                if (errorEl) {
                    errorEl.classList?.remove('d-none');
                    errorEl.innerHTML = 'An error occurred while submitting the form. Please review all fields and try again.';
                }
            }
        } catch (e) {
            console.error(e);
        }

        submitButtonLoaderEl?.classList?.add('d-none');
        this.nextButtonEl?.classList?.remove('custom-loading');

        this.querySelector('.form-section')?.classList.add("d-none");
        this.querySelector('.info-section')?.classList.add("d-none");
        this.querySelector('.form-successful-section')?.classList.remove("d-none");
    }

    validateField(name, inputElement, errorElement, validationType = "text") {
        const value = inputElement?.value.trim();
        let errorMessage = "";

        if (!value) {
            errorMessage = `${name} is required`;
        }
        else {
            switch (validationType) {
                case "email":
                    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (!emailPattern.test(value)) {
                        errorMessage = `${name} is not a valid email address`;
                    }
                    break;
            }
        }

        if (errorMessage) {
            errorElement.textContent = errorMessage?.replaceAll("_", " ").replaceAll("[]", "");
            errorElement.classList.remove("d-none");
        } else {
            errorElement.classList.add("d-none");
        }

        return !errorMessage;
    }

    manageCalendar() {
        const calendarDates = this.querySelector("#calendar_dates");
        const calendarMonthYear = this.querySelector("#calendar_month_year");
        const prevMonthBtn = this.querySelector("#prev_month");
        const nextMonthBtn = this.querySelector("#next_month");
        const quickSelectButtons = this.querySelectorAll('[data-calendar-quick-select] button');
        const selectedDateInput = this.querySelector("#expected_completion_date");

        let currentDate = new Date();
        let selectedDate = new Date();
        let today = new Date();
        today.setHours(0, 0, 0, 0);

        const updateCalendar = () => {
            calendarDates.innerHTML = "";
            const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
            const lastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0).getDate();

            calendarMonthYear.textContent = `${currentDate.toLocaleString("default", { month: "long" })} ${currentDate.getFullYear()}`;

            for (let i = 0; i < firstDay; i++) {
                const emptyDiv = document.createElement("div");
                calendarDates.appendChild(emptyDiv);
            }

            for (let i = 1; i <= lastDate; i++) {
                const dateDiv = document.createElement("div");
                dateDiv.textContent = i;
                dateDiv.dataset.date = i;

                let currentLoopDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
                currentLoopDate.setHours(0, 0, 0, 0);

                if (currentLoopDate < today) {
                    dateDiv.classList.add("disabled");
                } else {
                    dateDiv.addEventListener("click", function () {
                        selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), i);
                        updateCalendar();
                        updateSelectedDateInput();
                    });
                }

                if (
                    i === selectedDate.getDate() &&
                    currentDate.getMonth() === selectedDate.getMonth() &&
                    currentDate.getFullYear() === selectedDate.getFullYear()
                ) {
                    dateDiv.classList.add("selected");
                }

                calendarDates.appendChild(dateDiv);
            }

            prevMonthBtn.disabled =
                currentDate.getFullYear() === today.getFullYear() &&
                currentDate.getMonth() === today.getMonth();
        }

        const updateDate = (daysToAdd) => {
            selectedDate = new Date();
            selectedDate.setDate(selectedDate.getDate() + daysToAdd);
            currentDate = new Date(selectedDate);
            updateCalendar();
            updateSelectedDateInput();
        }

        const updateSelectedDateInput = () => {
            const localDateString = new Intl.DateTimeFormat("en-GB", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                timeZone: Intl.DateTimeFormat()?.resolvedOptions()?.timeZone,
            }).format(selectedDate);

            const [day, month, year] = localDateString.split("/");
            selectedDateInput.value = `${year}-${month}-${day}`;
        }

        prevMonthBtn.addEventListener("click", function () {
            currentDate.setMonth(currentDate.getMonth() - 1);
            updateCalendar();
        });

        nextMonthBtn.addEventListener("click", function () {
            currentDate.setMonth(currentDate.getMonth() + 1);
            updateCalendar();
        });

        quickSelectButtons.forEach((button) => {
            button.addEventListener("click", function () {
                const days = parseInt(this.getAttribute("data-days"));
                updateDate(days);
            });
        });

        updateCalendar();
    }

    manageFileUpload() {
        const dropArea = this.querySelector("#reference_files_drop_area");
        const fileInput = this.querySelector("#reference_files");
        const previewContainer = this.querySelector("#reference_files_preview");
        const referenceErrorEl = this.querySelector('[data-error-name="reference_files"]');

        if (!dropArea || !fileInput || !previewContainer) {
            return;
        }

        dropArea.addEventListener("dragover", (e) => {
            e.preventDefault();
            dropArea.classList.add("dragover");
        });

        dropArea.addEventListener("dragleave", () => {
            dropArea.classList.remove("dragover");
        });

        dropArea.addEventListener("drop", (e) => {
            e.preventDefault();
            dropArea.classList.remove("dragover");
            handleFiles(e.dataTransfer?.files);
        });

        fileInput.addEventListener("change", () => {
            handleFiles(fileInput.files);
        });

        const handleFiles = (files) => {
            if (this.referenceFiles.length > 10) {
                referenceErrorEl.classList.remove('d-none');
                referenceErrorEl.innerHTML = 'You’ve reached the upload limit. Only 10 files are allowed.';
                return;
            }
            referenceErrorEl.classList.add('d-none');
            referenceErrorEl.innerHTML = '';

            [...files].forEach(file => {
                if (!file.type.startsWith("image/")) return;

                if (this.referenceFiles.some(f => f.name === file.name && f.size === file.size)) {
                    return;
                }

                this.referenceFiles.push(file);

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = document.createElement("img");
                    img.src = e.target.result;

                    const previewBox = document.createElement("div");
                    previewBox.classList.add("upload-preview-box");

                    const removeBtn = document.createElement("button");
                    removeBtn.innerText = "✕";
                    removeBtn.classList.add("upload-preview-remove-btn");
                    removeBtn.onclick = () => removeFile(file, previewBox);

                    previewBox.appendChild(img);
                    previewBox.appendChild(removeBtn);
                    previewContainer.appendChild(previewBox);
                };
                reader.readAsDataURL(file);
            });

            fileInput.value = "";
        }

        const removeFile = (file, previewBox) => {
            this.referenceFiles = this.referenceFiles.filter(f => f.name !== file.name || f.size !== file.size);
            previewBox.remove();

            if (this.referenceFiles.length < 10) {
                referenceErrorEl.classList.add('d-none');
                referenceErrorEl.innerHTML = '';
            }
        }
    }
}

customElements.define('custom-form', CustomForm);
